// Copyright (c) 2020 Deere & Company

import {translate} from '../../shared/services/translation-service';

export const translatedMachinePutBackStatus = key => {

    const machinePutBackStatus = {
        N: 'NO_LOWERCASE',
        Y: 'YES_LOWERCASE'
    };

    return translate(machinePutBackStatus[key]);

};



// WEBPACK FOOTER //
// ./src/shared/services/machine-put-back-status.js